const MAX_AVATAR_WIDTH = 1920;
const MAX_AVATAR_HEIGHT = 1920;

export const getBoundedAvatarSize = (
    avatar: { width: number; height: number },
    maxSizes: { width: number; height: number } = { width: MAX_AVATAR_WIDTH, height: MAX_AVATAR_HEIGHT }
): [width: number, height: number] => {
    const useHeightForScale = avatar.width / avatar.height < maxSizes.width / maxSizes.height;

    if (useHeightForScale) {
        const newHeight = Math.min(avatar.height, maxSizes.height);
        return [Math.floor(avatar.width * (newHeight / avatar.height)), newHeight];
    }

    const newWidth = Math.min(avatar.width, maxSizes.width);
    return [newWidth, Math.floor(avatar.height * (newWidth / avatar.width))];
};
